"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _mapChina = require("./map-china.constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MapChinaComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MapChinaComponent, _Mixins);

  var _super = _createSuper(MapChinaComponent);

  function MapChinaComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MapChinaComponent);
    _this = _super.apply(this, arguments);
    _this.trafficLayer = null;
    _this.markers = {};
    _this.currentColor = '#387fc2';
    _this.delayFactor = 0;
    _this.mainPath = process.env.VUE_APP_BASE_URL;
    return _this;
  }

  (0, _createClass2.default)(MapChinaComponent, [{
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.map = null;
      this.trafficLayer = null;
      delete this.map;
      delete this.trafficLayer;
      this.logger.info('map china is destroyed!');
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.refreshMap();
      });
    }
  }, {
    key: "refreshMap",
    value: function refreshMap() {
      var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.map = this.initMap(this.$props.locations);
      this.map.addControl(new AMap.ToolBar({
        liteStyle: true
      }));

      if (this.$props.hasUpdateEvent) {
        this.map.addListener('click', function (event) {});
      }

      if (this.$props.initEvent) {
        var latLngs = routes ? routes : this.$props.routes;

        switch (this.$props.initEvent) {
          case 'polylines':
            this.initPolyline(latLngs);
            this.initTrafficLayer();
            break;

          case 'marker':
            this.initAllMarker(latLngs);
            break;

          case 'heatmap':
            this.initAllHeatMap(latLngs);
            break;
        }
      }
    }
  }, {
    key: "initMap",
    value: function initMap(center) {
      var element = this.$refs.chinaMarker;
      return new AMap.Map(element, {
        resizeEnable: true,
        zoomEnable: true,
        center: new AMap.LngLat(center.longitude, center.latitude),
        zoom: 5
      });
    }
  }, {
    key: "initAllHeatMap",
    value: function initAllHeatMap(locations) {
      var _this3 = this;

      var bounds = [];

      if (locations && locations.length >= 1 && this.map) {
        var finalWayPoints = [];
        locations.forEach(function (loc) {
          if (loc.length === 2) {
            bounds.push(new AMap.LngLat(loc[1], loc[0]));
            finalWayPoints.push({
              'lng': parseFloat(loc[1]),
              'lat': parseFloat(loc[0]),
              'count': 1
            });
          }
        });
        this.map.plugin(['AMap.Heatmap'], function () {
          var heatmap = new AMap.Heatmap(_this3.map, {
            radius: 20,
            opacity: [0.2, 0.6]
          });
          heatmap.setDataSet({
            data: finalWayPoints,
            max: 100
          });
        });
        this.fitBounds(bounds);
      }
    }
  }, {
    key: "initAllMarker",
    value: function initAllMarker(locations) {
      var _this4 = this;

      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (!this.markers[index]) {
        this.markers[index] = [];
      }

      var bounds = [];
      locations.forEach(function (loc, idx) {
        bounds.push(new AMap.LngLat(loc.longitude, loc.latitude));
        var marker = new AMap.Marker({
          position: new AMap.LngLat(loc.longitude, loc.latitude),
          map: _this4.map,
          details: loc
        });
        var markerContent = document.createElement('div');
        var markerImg = document.createElement('img');
        markerImg.className = 'marker-img';

        switch (loc.waypointType) {
          case 'P':
            markerImg.src = "".concat(_this4.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['red']);
            break;

          case 'D':
            markerImg.src = "".concat(_this4.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['blue']);
            break;

          case 'T':
            markerImg.src = "".concat(_this4.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['purple']);
            break;

          case 'R':
            markerImg.src = "".concat(_this4.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['black']);
            break;

          default:
            markerImg.src = "".concat(_this4.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['blue']);
            break;
        }

        markerContent.appendChild(markerImg);
        var markerSpan = document.createElement('span');
        markerSpan.className = 'marker-span';
        markerSpan.innerHTML = loc.waypointType === 'R' ? 'T' : (idx + 1).toString();
        markerContent.appendChild(markerSpan);
        marker.setContent(markerContent);

        _this4.markers[index].push(marker);
      });
      this.fitBounds(bounds);
    }
  }, {
    key: "addMarker",
    value: function addMarker(locations) {
      var _this5 = this;

      var colorCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var bounds = [];
      locations.forEach(function (loc, idx) {
        bounds.push(new AMap.LngLat(loc.longitude, loc.latitude));
        var marker = new AMap.Marker({
          position: new AMap.LngLat(loc.longitude, loc.latitude),
          map: _this5.map,
          details: loc
        });
        var markerContent = document.createElement('div');
        var markerImg = document.createElement('img');
        markerImg.className = 'marker-img';

        switch (loc.waypointType) {
          case 'P':
            markerImg.src = "".concat(_this5.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['red']);
            break;

          case 'D':
            markerImg.src = "".concat(_this5.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['blue']);
            break;

          case 'T':
            markerImg.src = "".concat(_this5.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['purple']);
            break;

          case 'R':
            markerImg.src = "".concat(_this5.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['black']);
            break;

          default:
            markerImg.src = "".concat(_this5.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['blue']);
            break;
        }

        markerContent.appendChild(markerImg);
        var markerSpan = document.createElement('span');
        markerSpan.className = 'marker-span';
        markerSpan.innerHTML = loc.waypointType === 'R' ? 'T' : (idx + 1).toString();
        markerContent.appendChild(markerSpan);
        marker.setContent(markerContent);

        _this5.markers[index].push(marker);
      });
      this.fitBounds(bounds);
    }
  }, {
    key: "removeMarker",
    value: function removeMarker() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.markers[index] && this.markers[index].length >= 1) {
        this.markers[index].forEach(function (loc) {
          if (typeof loc.setMap === 'function') {
            loc.setMap(null);
          }
        });
        this.markers[index] = [];
      }
    }
  }, {
    key: "initTrafficLayer",
    value: function initTrafficLayer() {
      var trafficLayer = new AMap.TileLayer.Traffic({
        zIndex: 10
      });
      trafficLayer.setMap(this.map);
      var toggleTrafficDiv = document.createElement('div');
      this.toggleTrafficView(toggleTrafficDiv, trafficLayer);
      toggleTrafficDiv['index'] = 1;
      this.map.K.appendChild(toggleTrafficDiv);
    }
  }, {
    key: "toggleTrafficView",
    value: function toggleTrafficView(controlDiv, trafficLayer) {
      // Set CSS for the control border.
      var controlUI = document.createElement('div');
      controlUI.setAttribute('class', 'toggle-traffic');
      controlDiv.appendChild(controlUI); // Set CSS for the control interior.

      var controlText = document.createElement('div');
      controlText.setAttribute('class', 'text active');
      controlText.innerHTML = "".concat(this.$i18n.t('planning.gMap.traffic'));
      controlUI.appendChild(controlText);
      var trafficOn = true;
      controlUI.addEventListener('click', function () {
        if (trafficOn) {
          trafficOn = false;
          controlText.setAttribute('class', 'text');
          trafficLayer.hide();
        } else {
          trafficOn = true;
          controlText.setAttribute('class', 'text active');
          trafficLayer.show();
        }
      });
    }
  }, {
    key: "initPolyline",
    value: function initPolyline(locations) {
      var _this6 = this;

      if (locations && locations.length >= 2) {
        var coordinates = [];
        locations.forEach(function (loc) {
          if (loc.latitude && loc.longitude) {
            coordinates.push({
              latitude: Number(loc.latitude),
              longitude: Number(loc.longitude),
              waypointType: loc.waypointType || 'P',
              district: loc.district,
              address: loc.displayAddress,
              startTime: loc.startTime,
              travellingTime: loc.time / 60,
              eta: loc.estimateTime,
              waitingTime: loc.waitingTime / 60,
              handlingTime: loc.handlingTime / 60,
              endTime: loc.endTime,
              shipmentReference: loc.shipmentReference,
              planId: loc.planId
            });
          }
        });
        var coordinateWaypoints = [];
        coordinates.forEach(function (loc, idx) {
          var icon = "".concat(_this6.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['blue']);

          switch (loc.waypointType) {
            case 'P':
              icon = "".concat(_this6.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['red']);
              break;

            case 'D':
              icon = "".concat(_this6.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['blue']);
              break;

            case 'T':
              icon = "".concat(_this6.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['purple']);
              break;

            case 'R':
              icon = "".concat(_this6.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['black']);
              break;

            default:
              icon = "".concat(_this6.mainPath, "/marker/").concat(_mapChina.DEFAULT_MAP_COLOR['blue']);
              break;
          }

          var marker = new AMap.Marker({
            position: new AMap.LngLat(loc.longitude, loc.latitude),
            icon: icon,
            map: _this6.map,
            details: loc
          });
          var markerContent = document.createElement('div');
          var markerImg = document.createElement('img');
          markerImg.className = 'marker-img';
          markerImg.src = icon;
          markerContent.appendChild(markerImg);
          var markerSpan = document.createElement('span');
          markerSpan.className = 'marker-span';
          markerSpan.innerHTML = loc.waypointType === 'R' ? 'T' : (idx + 1).toString();
          markerContent.appendChild(markerSpan);
          marker.setContent(markerContent);

          if (idx !== 0 || idx !== coordinates.length - 1) {
            coordinateWaypoints.push(new AMap.LngLat(parseFloat(loc.longitude), parseFloat(loc.latitude)));
          }
        });
        var driving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_TIME,
          map: this.map,
          showTraffic: false,
          hideMarkers: true,
          isOutline: false
        }); // driving.search(new AMap.LngLat(coordinates[0]['longitude'], 39.865042), new AMap.LngLat(116.427281, 39.903719), {
        //     // waypoints: coordinateWaypoints
        // }, (status, result) => {
        // });

        driving.search(new AMap.LngLat(coordinates[0]['longitude'], coordinates[0]['latitude']), new AMap.LngLat(coordinates[coordinates.length - 1]['longitude'], coordinates[coordinates.length - 1]['latitude']), {
          waypoints: coordinateWaypoints
        }, function (status, result) {});
      }
    }
  }, {
    key: "fitBounds",
    value: function fitBounds() {
      var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!this.map || locations.length === 0) {
        return;
      }

      this.map.setBounds(new AMap.ArrayBounds(locations));
    }
  }]);
  return MapChinaComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin));

MapChinaComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MapChinaComponent',
  props: {
    locations: {
      type: Object,
      required: true
    },
    routes: {
      type: Array
    },
    hasUpdateEvent: {
      type: Boolean,
      default: false
    },
    initEvent: {
      type: String
    },
    precision: {
      type: Number,
      default: 6
    }
  }
})], MapChinaComponent);
var _default = MapChinaComponent;
exports.default = _default;